var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIconbl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_110_4",
    "data-name": "Component 110 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.901,
    height: 22,
    viewBox: "0 0 17.901 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54_-_Outline",
    "data-name": "Path 54 - Outline",
    d: "M145.078,42.941a3.256,3.256,0,0,1-2.289-.95l-.246-.247.013-.012a3.257,3.257,0,0,1-.723-2.046V27.43h-.318a.841.841,0,0,1-.6-.248.852.852,0,0,1-.248-.6v-2.44a.847.847,0,0,1,.846-.846H145.8v-1.51a.847.847,0,0,1,.846-.846h5.946a.846.846,0,0,1,.846.846V23.3h4.285a.852.852,0,0,1,.6.248.84.84,0,0,1,.248.6v2.44a.846.846,0,0,1-.846.846H157.4V39.658a3.259,3.259,0,0,1-3.242,3.254v0Zm0-.667C154.848,42.241,144.422,42.274,145.078,42.274Zm.016-.359C144.491,41.915,154.752,41.883,145.093,41.915Zm-.007-.667h.006l9.064-.03a1.564,1.564,0,0,0,1.556-1.562V27.43H143.525V39.688a1.561,1.561,0,0,0,1.561,1.561ZM142.36,25.737h14.517V24.99H142.36Zm5.132-2.44h4.254v-.664h-4.254Z",
    transform: "translate(-140.668 -20.941)",
    fill: "#24abe2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55_-_Outline",
    "data-name": "Path 55 - Outline",
    d: "M337.977,225.694h0a.667.667,0,0,1-.475-.2.676.676,0,0,1-.2-.475v-6.384a.671.671,0,0,1,1.343,0v6.384a.676.676,0,0,1-.2.475A.667.667,0,0,1,337.977,225.694Z",
    transform: "translate(-329.026 -208.724)",
    fill: "#24abe2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56_-_Outline",
    "data-name": "Path 56 - Outline",
    d: "M262.767,225.694a.667.667,0,0,1-.475-.2.676.676,0,0,1-.2-.475v-6.384a.671.671,0,0,1,1.343,0v6.384a.675.675,0,0,1-.2.475A.666.666,0,0,1,262.767,225.694Z",
    transform: "translate(-256.983 -208.724)",
    fill: "#24abe2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57_-_Outline",
    "data-name": "Path 57 - Outline",
    d: "M413.187,225.694a.666.666,0,0,1-.475-.2.675.675,0,0,1-.2-.475v-6.384a.671.671,0,0,1,1.343,0v6.384a.676.676,0,0,1-.2.475A.667.667,0,0,1,413.187,225.694Z",
    transform: "translate(-401.07 -208.724)",
    fill: "#24abe2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconbl);
export default __webpack_public_path__ + "static/media/delete_iconbl.6053cdd14d2ed3df5c3b5ceaca4a47a7.svg";
export { ForwardRef as ReactComponent };